<template>
  <transition name="fade">
    <div v-if="visible" class="ui-modal-overlay">
      <div class="ui-modal-window">
        <div class="ui-modal-header">
          <span class="ui-modal-title">{{ title }}</span>
          <button class="ui-modal-close" @click="$emit('close')" type="button">×</button>
        </div>

        <div class="ui-modal-body">
          <div class="ui-modal-content">
            <slot>
              <p class="ui-modal-message">{{ content }}</p>
            </slot>
          </div>
        </div>

        <div v-if="showFooter" class="ui-modal-footer">
          <button
            v-if="showCancel"
            class="ui-modal-button ui-modal-button--secondary"
            @click="$emit('cancel')"
            type="button"
          >
            {{ cancelText }}
          </button>
          <button
            class="ui-modal-button ui-modal-button--primary"
            @click="$emit('ok')"
            type="button"
          >
            {{ okText }}
          </button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'BaseModal',
  props: {
    visible: Boolean,
    title: { type: String, default: '提示' },
    content: { type: String, default: '' },
    okText: { type: String, default: '确定' },
    cancelText: { type: String, default: '取消' },
    showCancel: { type: Boolean, default: false },
    showFooter: { type: Boolean, default: true }
  }
}
</script>

<style>
.ui-modal-overlay {
  position: fixed;
  z-index: 10000;
  inset: 0;
  background: rgba(0, 0, 0, 0.14);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.ui-modal-window {
  width: 100%;
  max-width: 520px;
  background: #ffffff;
  border-radius: 10px;
  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.18);
  overflow: hidden;
}

.ui-modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 18px 20px;
  border-bottom: 1px solid #f0f0f0;
}

.ui-modal-title {
  font-size: 16px;
  font-weight: 600;
  color: #111111;
}

.ui-modal-close {
  width: 32px;
  height: 32px;
  border: 0;
  border-radius: 50%;
  background: #f4f4f4;
  color: #666666;
  font-size: 18px;
  cursor: pointer;
  line-height: 1;
}

.ui-modal-body {
  padding: 24px 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.ui-modal-content {
  width: 100%;
}

.ui-modal-message {
  margin: 0;
  line-height: 1.75;
  color: #444444;
  text-align: left;
  word-break: break-word;
}

.ui-modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 18px 20px;
  border-top: 1px solid #f0f0f0;
  background: #fafafa;
}

.ui-modal-button {
  min-width: 90px;
  padding: 10px 16px;
  border-radius: 999px;
  border: 1px solid transparent;
  font-size: 14px;
  cursor: pointer;
}

.ui-modal-button--primary {
  background: #ff6600;
  color: #ffffff;
}

.ui-modal-button--secondary {
  background: #ffffff;
  color: #333333;
  border-color: #e0e0e0;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

@media (max-width: 520px) {
  .ui-modal-window {
    max-width: 100%;
  }

  .ui-modal-body {
    padding: 18px 16px;
  }

  .ui-modal-header,
  .ui-modal-footer {
    padding: 16px;
  }
}
</style>